import * as THREE from 'three';
import utils from '../../utils';
import labelFactory from '../../LabelFactory';
import constants from '../../config/Constants';
import settings from '../../config/Settings';
import planetsData from '../../config/PlanetsData';

class Planets {
  constructor() {
    const planets = this.createPlanets()
    this.three = {
      planets: planets,
      labels: planets.map(planet => (planet.label)),
    }
  }

  createPlanets() {
    return Object.keys(planetsData).map(planetKey => this.createPlanet(planetsData[planetKey]));
  }

  createPlanet(planetData) {
    const planet = utils.createSphere(planetData.radius, this.getPlanetMaterial(planetData))
    planet.translateZ(planetData.orbitRadius)
    planet.rotateX(THREE.Math.degToRad(planetData.axialTiltDeg))

    // Create label
    const label = labelFactory.createLabel('planet', planetData.name, planetData.labelScaleCoefficient)
    label.position.set(planet.position.x, planet.position.y, planet.position.z)
    label.maxDistance = planetData.labelMaxDistance

    const orbitLine = this.getOrbitLine(planetData)

    const group = new THREE.Group()
    group.type = 'planet'
    group.name = planetData.name
    group.mainObject = planet
    group.label = label
    group.orbit = orbitLine
    group.add(planet)
    group.add(label)
    group.add(orbitLine)
    group.position.set(0,0,0)
    group.rotateY(Math.random() * Math.PI*2)
    return group
  }

  getPlanetMaterial(planetData) {
    const materialData = {
      map: new THREE.TextureLoader().load(planetData.materialMap),
    }
    if (planetData.materialBumpMap) {
      materialData.bumpMap = new THREE.TextureLoader().load(planetData.materialBumpMap)
      materialData.bumpScale = planetData.materialBumpScale
    }
    return new THREE.MeshPhongMaterial(materialData)
  }

  getOrbitLine(planetData) {
    var opacity = 0.5
    var geometry = new THREE.CircleGeometry(planetData.orbitRadius, 1024, 0, 2 * 3.1415)
    var material = new THREE.LineBasicMaterial({color: 0xffffff, transparent: true, opacity: opacity})
    var circle = new THREE.Line(geometry, material)
    circle.geometry.vertices.shift()
    circle.rotateOnAxis(new THREE.Vector3(1, 0, 0), -Math.PI/2)
    return circle
  }

  rotatePlanets(deltaMilli) {
    this.three.planets.map((planetGroup) => {
      const planetSettings = planetsData[planetGroup.name];
      const rotationPeriodInSeconds = planetSettings.rotationPeriodInSeconds;
      const deltaSec = (deltaMilli / 1000);
      const realDeltaSec = deltaSec * settings.timeSecond;
      const angle = 2 * Math.PI * (realDeltaSec / rotationPeriodInSeconds);
      planetGroup.mainObject.rotateY(angle);
      return null;
    })
  }

  translatePlanets(deltaMilli) {
    this.three.planets.map((planetGroup) => {
      const planetSettings = planetsData[planetGroup.name];
      const orbitalPeriodInSeconds = constants.EARTH_ORBITAL_PERIOD_IN_SECONDS * planetSettings.earthBasedOrbitalPeriod;
      const deltaSec = (deltaMilli / 1000);
      const realDeltaSec = deltaSec * settings.timeSecond;
      const angle = 2 * Math.PI * (realDeltaSec / orbitalPeriodInSeconds);
      planetGroup.rotateY(angle);
      return null;
    })
  }
}

export default Planets